// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/StandardVocalAttributesRating.jsx

import React from 'react';
import { useFixedTForResource } from '../../../../../locales/useFixedTForResource';
import VASRatingInput from '../../../../../components/form-items/VASRatingInput';

function StandardVocalAttributesRating({
  overallSeverity,
  setOverallSeverity,
  roughness,
  setRoughness,
  breathiness,
  setBreathiness,
  strain,
  setStrain,
  customVasLabel,
  setCustomVasLabel,
  customVasValue,
  setCustomVasValue,
}) {
  const t = useFixedTForResource('CAPEVR');

  return (
    <div className="capevr-rating">
      {/* Etiquetes per als extrems de la escala */}
      <div className="capevr-scale-container">
        <span className="capevr-scale-label capevr-scale-left">{t('normal')}</span>
        <span className="capevr-scale-label capevr-scale-right">{t('extreme')}</span>
      </div>
      
      {/* Els 4 sliders del CAPE-Vr */}
      <VASRatingInput
        label={t('overall_severity')}
        VASValue={overallSeverity} 
        setVASValue={setOverallSeverity}
        index={0}
      />
     <VASRatingInput
        label={t('roughness')}
        VASValue={roughness}
        setVASValue={setRoughness}
        index={1}
      />
      <VASRatingInput
        label={t('breathiness')}
        VASValue={breathiness}
        setVASValue={setBreathiness}
        index={2}
      />
      <VASRatingInput
        label={t('strain')}
        VASValue={strain}
        setVASValue={setStrain}
        index={3}
      />
      <div className="capevr-vocal-attribute-rating capevr-custom-vas">
        <div className="capevr-rating-row">
          <div className="capevr-rating-label capevr-custom-vas__label">
            <input
              className="app-input blank-vas-name-input capevr-custom-vas__input"
              type="text"
              aria-label={t('cape_vr_custom_rating_label')}
              placeholder="…"
              value={customVasLabel}
              onChange={event => {
                const label = event.target.value;
                setCustomVasLabel(label);
                if (!label.trim()) setCustomVasValue(null);
              }}
            />
          </div>
          {customVasLabel.trim() && (
            <input
              type="range"
              aria-label={customVasLabel}
              min="0"
              max="100"
              value={customVasValue ?? 0}
              onChange={event => setCustomVasValue(Number(event.target.value))}
              className="capevr-slider"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default StandardVocalAttributesRating;
